// extracted by mini-css-extract-plugin
module.exports = {"videos":"Videos_videos__-dwgp","videos_fullCard":"Videos_videos_fullCard__1j8JX"};